module.exports = __webpack_public_path__ + "static/media/airquality.80bac0bd.png";